import { forwardRef, useEffect } from "react";

interface Props {
  rows: number;
  cols: number;
  value: string;
  placeholder?: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  onFocus?: () => void;
  onChange?: () => void;
}

/**
 * 자동 높이 조절 텍스트 에어리어
 *
 * @param rows 행 수
 * @param cols 열 수
 * @param value 입력 값
 * @param setValue 입력 값 변경 함수
 * @param onFocus 포커스 이벤트
 * @param onChange 입력 값 변경 이벤트
 */
export const AutoResizeTextArea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const { rows, cols, value, placeholder, setValue, onFocus } = props;

  const textareaAutoHeight = () => {
    const refObject = ref as React.RefObject<HTMLTextAreaElement>;
    if (refObject.current) {
      refObject.current.style.height = "auto";
      refObject.current.style.height = refObject.current.scrollHeight + "px";
    }
  };

  useEffect(() => {
    textareaAutoHeight();
  }, [value]);

  return (
    <textarea
      className="auto-resize-textarea"
      rows={rows}
      cols={cols}
      value={value}
      ref={ref}
      onFocus={onFocus}
      onChange={(e) => {
        setValue(e.target.value);
      }}
      placeholder={placeholder}
    ></textarea>
  );
});
